export default __webpack_public_path__ + "static/media/logo_home.75b6d0c1.svg";